import React from 'react';
import { XCircle } from 'lucide-react';
export function ComparisonTable() {
  return <section className="py-16 bg-crema paper-texture" data-id="element-1">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-2">
        <h2 className="text-3xl font-heading font-bold text-marron mb-10 text-center" data-id="element-3">
          ❌ El Problema con las Soluciones que Ya Probaste
        </h2>

        <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-marron/10" data-id="element-4">
          <div className="overflow-x-auto" data-id="element-5">
            <table className="w-full text-left border-collapse" data-id="element-6">
              <thead data-id="element-7">
                <tr className="bg-marron text-white" data-id="element-8">
                  <th className="p-4 sm:p-5 font-bold uppercase text-sm tracking-wider w-1/3" data-id="element-9">
                    Lo que probaste
                  </th>
                  <th className="p-4 sm:p-5 font-bold uppercase text-sm tracking-wider" data-id="element-10">
                    Por qué no alcanzó
                  </th>
                </tr>
              </thead>
              <tbody className="text-marron" data-id="element-11">
                {[{
                tried: 'Ibuprofeno y analgésicos',
                why: 'Tapan el síntoma, no la causa. Y con el tiempo, dañan el estómago y los riñones.'
              }, {
                tried: 'Cápsulas de cúrcuma',
                why: 'Sin el activador correcto, el 80% se elimina sin absorberse. Es dinero tirado.'
              }, {
                tried: 'Tés de hierbas sueltos',
                why: 'Una hierba sola tiene poder limitado. La sinergia lo multiplica hasta 20 veces.'
              }, {
                tried: 'Dietas restrictivas',
                why: 'Insostenibles, poco placenteras y sin enfoque en las combinaciones correctas.'
              }, {
                tried: 'Consultas médicas',
                why: '«Es normal a tu edad.» — Y chau. Sin herramientas reales para hacer algo vos.'
              }].map((row, i) => <tr key={i} className={i % 2 === 0 ? 'bg-crema/30' : 'bg-white'} data-id="element-12">
                    <td className="p-4 sm:p-5 border-b border-gray-100 font-bold text-terracota align-top" data-id="element-13">
                      {row.tried}
                    </td>
                    <td className="p-4 sm:p-5 border-b border-gray-100 align-top" data-id="element-14">
                      {row.why}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>;
}